import gql from 'graphql-tag';

const cancelledGuaranteePurchasesAuditsQuery = gql`
  query cancelledPurchaseAudits(
      $cancelledPurchaseId: Int!
      $startDate: String
      $endDate: String
      $size: Int
      $offset: Int
    ) {
    cancelledPurchaseAudits(
      cancelledPurchaseId: $cancelledPurchaseId
      startDate: $startDate
      endDate: $endDate
      size: $size
      offset: $offset
      ) {
      changeset
      createdAt
      event
      id
      itemType
      timeStamp
      versionAuthor
      whodunnit
    }
  }
`;

export default cancelledGuaranteePurchasesAuditsQuery;
